/**
 * Created by vsuthar on 2/12/20
 * Project: App Portal ©Palo Alto Networks
 */

import hubLogo from '../images/hub/logo-hub-v2.svg'
import PANW_Orange from '../images/PANW_V2_full_logo_orange.svg'
import PANW_Orange_black from '../images/PANW_V2_full_logo_orange_black.svg'

export const HUB_V2_Logo = hubLogo
export const PANW_ORANGE = PANW_Orange
export const PANW_ORANGE_BLACK = PANW_Orange_black
